import { FC } from 'react';
import { IonButton, IonContent } from '@ionic/react';
import { createUseStyles } from 'react-jss';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useSubscription } from '@meraki-internal/state';
import { Modal } from '../components/Modal';
import { GetHelpPromptViewModel } from './GetHelpPromptViewModel';

const GUIDE_IMAGES = ['3.jpg', '5.jpg', '7.jpg', '10.jpg'];

const useStyles = createUseStyles({
    ionContent: {
        '--padding-top': '0',
        '--padding-bottom': '0',
        height: '100%',
        display: 'flex'
    },
    contentWrapper: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: '0 24px',
        textAlign: 'center'
    },
    actions: {
        marginTop: 24,
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
        width: '100%',
        maxWidth: 280,
        margin: '24px auto 0'
    }
});

export const GetHelpPromptModal: FC = () => {
    const classes = useStyles();
    const vm = useInstance(GetHelpPromptViewModel);
    useSubscription(() => vm);
    const isOpen = vm.isOpen();

    const showCount = vm.getShowCount();
    const imageIndex = (showCount - 1) % GUIDE_IMAGES.length;
    const imageSrc = `./assets/images/inspiration/${GUIDE_IMAGES[imageIndex >= 0 ? imageIndex : 0]}`;

    return (
        <Modal
            title=""
            data-id="get-help-prompt-modal"
            desktopMinHeight={500}
            isOpen={isOpen}
            closeHandler={vm.close}
        >
            <IonContent className={classes.ionContent}>
                <div className={classes.contentWrapper}>
                    <div style={{marginBottom: 20}}>
                        <img
                            src={imageSrc}
                            alt="Inspiration"
                            style={{
                                width: '80%',
                                maxWidth: 300,
                                borderRadius: 12
                            }}
                        />
                    </div>
                    <h1 style={{fontSize: 22, marginTop: 0, marginBottom: 20}}>
                        Want a personal guide to find the right services for you?
                    </h1>

                    <p style={{marginTop: 0, marginBottom: 0, color: 'var(--ion-color-medium)'}}>
                        We'll build you a plan with recommended resources!
                    </p>

                    <div className={classes.actions}>
                        <IonButton
                            fill="clear"
                            color="primary"
                            onClick={vm.close}
                            data-id="get-help-no"
                        >
                            No thanks
                        </IonButton>

                        <IonButton
                            expand="block"
                            fill="solid"
                            color="primary"
                            onClick={vm.acceptAndOpenSurvey}
                            data-id="get-help-yes"
                        >
                            Yes, I'd like a guide
                        </IonButton>
                    </div>
                </div>
            </IonContent>
        </Modal>
    );
};
